import React, { useState } from "react";
import PropTypes from "prop-types";
import axiosInstance from "../axios/axios";
import SuccessMessage from "./SuccessMessage";
import ErrorMessage from "./ErrorMessage";

const DeleteRequest = ({ id, setOpenDelete }) => {
  const [success, setSuccess] = useState(false);
  const [errorOccurred, setErrorOccurred] = useState(false); // Handle error state

  const handleDeleteJobs = async (id) => {
    try {
      const response = await axiosInstance.delete(`jobs/${id}`);
      setSuccess(true);
      console.log(response);
      setOpenDelete(false);
      window.location.reload("/dashboard/jobs");
    } catch (error) {
      setErrorOccurred(true); // Trigger error message display
      console.error(error);
    }
  };

  return (
    <div className="min-h-screen h-full xsm:fixed flex w-full items-center justify-center absolute rejection-card flex-col top-0 left-0">
      {success && <SuccessMessage message="Job deleted successfully" />}
      {errorOccurred && (
        <ErrorMessage message="An error occurred while deleting the job." />
      )}
      <div className="bg-white w-2/3 flex flex-col items-center justify-center p-3 rounded-3xl gap-2">
        <span className="reject-text">Confirm Delete</span>
        <span className="text-center text-sm text-[#475467]">
          Are you sure you want to delete this job?
        </span>
        <section className="flex gap-3 my-3">
          <button
            className="btn w-full text-white hover:bg-[#780202] bg-[#BC1518]"
            onClick={() => setOpenDelete(false)}
          >
            Cancel
          </button>
          <button
            onClick={() => handleDeleteJobs(id)}
            className="btn w-full text-white hover:bg-[#1E4929] bg-[#049645]"
          >
            Confirm
          </button>
        </section>
      </div>
    </div>
  );
};

DeleteRequest.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  setOpenDelete: PropTypes.func.isRequired,
};

export default DeleteRequest;
